import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity, Baby, TestTube, Eye, HeartPulse, Stethoscope, Syringe, Users } from 'lucide-react';
const TOP_SERVICES = [{
  title: 'General Consultations',
  icon: <Stethoscope className="w-7 h-7" data-id="element-184" />,
  desc: 'Expert medical advice and treatment for common illnesses and health concerns.',
  slug: 'general-medical-consultations'
}, {
  title: 'Maternal Care',
  icon: <Baby className="w-7 h-7" data-id="element-185" />,
  desc: 'Comprehensive antenatal and postnatal care for mothers and babies.',
  slug: 'antenatal-care'
}, {
  title: 'Laboratory Services',
  icon: <TestTube className="w-7 h-7" data-id="element-186" />,
  desc: 'Accurate and fast diagnostic testing including blood work and DNA testing.',
  slug: 'laboratory-services'
}, {
  title: 'Ultrasound & ECG',
  icon: <Activity className="w-7 h-7" data-id="element-187" />,
  desc: 'Advanced imaging and heart monitoring for precise medical diagnosis.',
  slug: 'ultrasound-services'
}, {
  title: 'Chronic Disease',
  icon: <HeartPulse className="w-7 h-7" data-id="element-188" />,
  desc: 'Ongoing management and support for diabetes, hypertension, and more.',
  slug: 'chronic-disease-management'
}, {
  title: 'Optician Services',
  icon: <Eye className="w-7 h-7" data-id="element-189" />,
  desc: 'Professional eye examinations and vision care solutions.',
  slug: 'optician-services'
}, {
  title: 'Immunizations',
  icon: <Syringe className="w-7 h-7" data-id="element-190" />,
  desc: 'Essential vaccines for children and adults to prevent infectious diseases.',
  slug: 'immunizations'
}, {
  title: 'Family Planning',
  icon: <Users className="w-7 h-7" data-id="element-191" />,
  desc: 'Confidential counseling and contraceptive services for family planning.',
  slug: 'family-planning'
}];
export function ServicesOverview() {
  return <section className="py-20 bg-brand-lighter" data-id="element-192">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-194">
          <div className="max-w-2xl" data-id="element-195">
            <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-196">
              Our Services
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-4" data-id="element-197">
              Comprehensive Healthcare Solutions
            </h2>
            <p className="text-slate-600 text-lg" data-id="element-198">
              We offer a wide range of medical services under one roof, ensuring
              you and your family receive complete care.
            </p>
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 text-brand-navy font-semibold hover:text-brand-red transition-colors shrink-0" data-id="element-199">
            View All Services <ArrowRight className="w-5 h-5" data-id="element-200" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-201">
          {TOP_SERVICES.map((service, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-soft-lg transition-all duration-300 border border-slate-100 group relative overflow-hidden" data-id="element-202">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" data-id="element-203" />

              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center mb-6 text-brand-gold group-hover:scale-110 transition-transform duration-300" data-id="element-204">
                {service.icon}
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-3 group-hover:text-brand-red transition-colors" data-id="element-205">
                {service.title}
              </h3>

              <p className="text-slate-600 text-sm mb-6 line-clamp-2" data-id="element-206">
                {service.desc}
              </p>

              <div className="flex items-center justify-between mt-auto pt-4 border-t border-slate-50" data-id="element-207">
                <Link to={`/services/${service.slug}`} className="text-sm font-medium text-brand-navy hover:text-brand-red transition-colors" data-id="element-208">
                  Learn More
                </Link>
                <Link to={`/book?service=${service.slug}`} className="w-8 h-8 rounded-full bg-brand-lighter flex items-center justify-center text-brand-navy hover:bg-brand-red hover:text-white transition-colors" data-id="element-209">
                  <ArrowRight className="w-4 h-4" data-id="element-210" />
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}